import React from "react";
import { Button, Form, Input, Select } from "antd";
import PhoneNumberInput from "../../../../components/shared/PhoneNumberInput";
import RequiredLabel from "./RequiredLabel";

const DESIGNATIONS = ["Mr", "Mrs", "Ms", "Dr", "Miss"].map((d) => ({ label: d, value: d }));

export interface BasicInfoValues {
  designation?: string;
  name: string;
  email: string;
  phone: string;
}

interface Props {
  initialValues: BasicInfoValues | null;
  onNext: (values: BasicInfoValues) => void;
}

export default function BasicInfoStep({ initialValues, onNext }: Props) {
  const [form] = Form.useForm<BasicInfoValues>();

  return (
    <div className="customize-tour-form__step-body customize-tour-form__step-body--basic">
      <Form form={form} layout="vertical" initialValues={initialValues || undefined} onFinish={onNext}>
        <Form.Item label={<RequiredLabel>Your Name</RequiredLabel>} required={false}>
          <div className="customize-tour-form__name-row">
            <Form.Item name="designation" noStyle rules={[{ required: true, message: "Please select a designation" }]}>
              <Select placeholder="Designation" options={DESIGNATIONS} />
            </Form.Item>
            <Form.Item name="name" noStyle rules={[{ required: true, message: "Please enter your name" }]}>
              <Input placeholder="What should we call you?" />
            </Form.Item>
          </div>
        </Form.Item>

        <Form.Item
          label={<RequiredLabel>Email</RequiredLabel>}
          name="email"
          required={false}
          rules={[
            { required: true, message: "Please enter your email" },
            { type: "email", message: "Please enter a valid email" },
          ]}
        >
          <Input placeholder="Example: johndoe@gmail.com" />
        </Form.Item>

        <Form.Item
          label={<RequiredLabel>Contact Number</RequiredLabel>}
          name="phone"
          required={false}
          rules={[{ required: true, message: "Please enter your contact number" }]}
        >
          <PhoneNumberInput placeholder="Example: 123445467" />
        </Form.Item>

        <div className="customize-tour-form__actions customize-tour-form__actions--center">
          <Button type="primary" htmlType="submit" className="customize-tour-form__btn-continue">
            Continue
          </Button>
        </div>
      </Form>
    </div>
  );
}
